export default __webpack_public_path__ + "static/media/48CE2BB7-E78E-43F3-A31E-5D4AA9206D78_1_105_c.ac75db4d.jpeg";